import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import router from '@/router';
import { removeCookie, getCookie } from '../assets/js/cookie';

// 401 弹窗防抖标志，避免重复弹出登录过期提示
let isShow = false

// 根据环境拼接 API 基础地址
const url = (process.env.VUE_APP_ENV_NAME === 'dev' || process.env.VUE_APP_ENV_NAME === 'dev-pro')
  ? process.env.VUE_APP_API_URL
  : window.location.origin + process.env.VUE_APP_API_URL_PATH

// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// create an axios instance
const service = axios.create({
  baseURL: url, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 240000 // request timeout
})

// 业务层自行处理的非 200 状态码，统一 resolve res.data
const RESOLVE_CODES = new Set([
  413, // 版权中心token失效
  414, // 上传文件失败
  415, // 版权人信息不一致
  416, // 未实名
  417, // 无默认地址
  418, // 418 该权益未扣费，且只有一个可以扣费的套餐；同时返回改套餐的id
  419, // 419 该权益未扣费，且有多个可以扣费的套餐，调用获取相关套餐的接口，选择套餐
  420, // 420 该权益未扣费，且用户没有相关可以扣费的套餐，提示用户购买相关套餐
  421, //安装包下载中
  440, //验证码失败
  460, //一键同步失败
  400, //400-提示性错误
  437, //请输入正确的验证码（短信验证码错误）
  471, //存在一个正在处理中的批次
  472, //存在一个待确定的批次
  550, //登录失败（用户名密码错误）
  560, //560-流程错误
  5404, //5404-没有审查流程
  0, //0-获取登录验证码成功
  1, //1-获取待验证用户信息成功
  2, //2-获取发送短信验证码成功
  3, //3-授权成功
])

// 判断 token 是否有效，避免重复调用 getCookie
function isValidToken(token) {
  return token && token !== 'null' && token !== null
}

// 统一处理 401 未授权：防抖 + 延迟重置
function handleUnauthorized() {
  if (isShow) return
  showLogout()
  isShow = true
  setTimeout(() => {
    if (isValidToken(getCookie())) {
      isShow = false
    }
  }, 1500)
}

// request interceptor
service.interceptors.request.use(
  config => {
    const token = getCookie()
    if (token) {
      config.headers['Token'] = token
    }
    config.headers['platform'] = 1
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

function showLogout() {
  // 保存当前路由信息到localStorage，排除登录页
  const currentRoute = router.currentRoute.value;
  removeCookie('yw')
  if (currentRoute.path === '/notice-detail') {
    router.replace({ path: '/login', query: {
      redirectPath: currentRoute.fullPath
    }})
  } else {
    router.replace({ path: '/login' })
  }
  ElMessageBox.confirm('登录状态已过期，请重新登录', '系统提示', {
    confirmButtonText: '确定',
    // cancelButtonText: '取消',
    type: 'warning',
    confirmButtonClass: 'btn-item btn-active',
    showCancelButton: false
    // cancelButtonClass: 'btn-item',
  }).then(() => {
    // router.replace({ path: '/login' })
  }).catch(() => {})
}

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  res => {
    console.log('res', res);
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = res.data.message || '接口异常'
    if (code === 401) {
      handleUnauthorized()
    } else if (RESOLVE_CODES.has(code)) {
      return Promise.resolve(res.data)
    } else if (code === 500) {
      if (res.request.responseURL.includes('/copyright/loginPre') ||
      res.request.responseURL.includes('/copyright/loginNext')) {
        ElMessage({
          showClose: true,
          message: msg,
          type: 'error',
          duration: 5000
        })
      } else {
        ElMessage.error(msg)
      }
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {     
      // if (!res.request.responseURL.includes('/copyright/addInformation')) {
      ElMessage.error(msg)
      return Promise.reject('error')
    } else {
      return Promise.resolve(res.data)
    }
  },
  error => {
    console.log('error', error);
    const href = window.location.href
    // 使用可选链，避免无 response 时（如网络断开）抛出二次异常
    if (href.indexOf('stop-service') === -1 && error.response?.status === 502) {
      router.push({ path: '/stop-service' })
    }
    if (error.response?.data?.code === 401) {
      handleUnauthorized()
    }
    return Promise.reject(error)
  }
)

export default service
